import { useIntl } from 'react-intl'
import styled from 'styled-components'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import LoadingIndicator from 'components/Common/Loading/LoadingIndicator'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  background-color: ${props => props.theme.palette.neutral.default.eight};
`

function WrappedLoadingState() {
  const intl = useIntl()
  return (
    <Container className="app-theme-inverse">
      <LoadingIndicator inline ballSize={24} childrenBelow>
        <VerticalSpacer gap={8}>
          <Heading variant="heading5">{intl.formatMessage({ id: 'ByriZOoVV-Hvg0EH3blp', defaultMessage: 'Loading a year of travel...', description: 'Loading state heading for Wrapped page in the year-end travel wrapped summary' })}</Heading>
          <BodyText variant="small" colour="neutral-two">
            {intl.formatMessage({ id: 'r9a5LnPeuqzUkJG4Rfiv', defaultMessage: 'Preparing travel highlights', description: 'Loading state body text for Wrapped page in the wrapped summary' })}
          </BodyText>
        </VerticalSpacer>
      </LoadingIndicator>
    </Container>
  )
}

export default WrappedLoadingState
